<template>
  <v-autocomplete
    :items="businessEntitiesList"
    item-value="id"
    item-text="businessEntityName"
    v-model="businessEntityIdValue"
    :label="labelValue"
    :clearable="clearable ? clearable : false"
    :readonly="readonly"
    :rules="[requiredCheck()]"
    :dense="dense"
    :hide-details="hideDetails ? hideDetails : false"
    outlined
  ></v-autocomplete>
</template>

<script>
import { mapActions } from 'vuex'
import { required } from '@/lib/formValidations'
import { ALL_BUSINESS_ENTITIES } from '@/lib/constants/businessEntities'

export default {
  props: [
    'value',
    'isRequired',
    'readonly',
    'clearable',
    'dense',
    'hideDetails',
    'label',
    'includeAllBusinessEntitiesOption'
  ],
  data () {
    return {
      businessEntitiesList: []
    }
  },
  computed: {
    businessEntityIdValue: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
        this.$emit('businessEntityIdChange', newValue)

        if (newValue === null || newValue === undefined) {
          this.$emit('businessEntityNameChange', null)
          return
        }

        let businessEntity = this.businessEntitiesList.find((element) => {
          return element.id === newValue
        })

        this.$emit('businessEntityNameChange', businessEntity ? businessEntity.businessEntityName : null)
      }
    },
    labelValue: {
      get () {
        return this.label ? this.label : 'Business Entity'
      }
    }
  },
  methods: {
    ...mapActions('businessEntities', [
      'getBusinessEntityOptions'
    ]),
    requiredCheck () {
      return !this.isRequired || required(this.labelValue)
    }
  },
  created () {
    this.getBusinessEntityOptions().then((businessEntities) => {
      this.businessEntitiesList = this.includeAllBusinessEntitiesOption
        ? [
          {
            id: ALL_BUSINESS_ENTITIES,
            businessEntityName: 'All Business Entities'
          },
          ...businessEntities
        ]
        : businessEntities
    })
  }
}
</script>
